import { TypeIdSchema, user } from '@unipile/db';
import { Type, type Static } from '@sinclair/typebox';
import { createInsertSchema, createSelectSchema } from 'drizzle-typebox';

export const UserSchema = createSelectSchema(user);

export const InsertUserSchema = createInsertSchema(user);

export const PublicUserSchema = Type.Composite([
  Type.Omit(UserSchema, ['id', 'public_id', 'password', 'mfa_secret']),
  Type.Object({
    object: Type.Literal('User'),
    id: TypeIdSchema('user'),
  }),
]);

export type User = typeof user.$inferSelect;
export type InsertUser = typeof user.$inferInsert;
export type PublicUser = Static<typeof PublicUserSchema>;
